/**
 * 2 Nov 2026 night (D-1103-SPEED-2): "Show the last picture while it updates".
 *   UI_KEEP_LAST_PICTURE  Yes (default)  the app keeps each screen's last answer for 30 minutes, so a tab switch shows
 *                                        it at once and refreshes it in the background ("Updating…").
 *                                        No: the answers are kept 5 minutes, as before.
 * The row rides along with /api/dayplan (every role already reads that), so the app knows it without a new request.
 */
export const KEEP_PICTURE_KEY = 'UI_KEEP_LAST_PICTURE';
export const KEEP_PICTURE_MS = 30 * 60_000;
export const DEFAULT_KEEP_MS = 5 * 60_000;

type Settings = Record<string, string | undefined> | undefined | null;

/** On unless the row says No (a site with no row is on). */
export function keepPictureOn(settings: Settings): boolean {
  return !/^(no|false|off|0)$/i.test(String(settings?.[KEEP_PICTURE_KEY] ?? '').trim());
}

/** How long the app keeps an answer nobody is looking at. */
export const keepMsFor = (settings: Settings): number => (keepPictureOn(settings) ? KEEP_PICTURE_MS : DEFAULT_KEEP_MS);
